import { Link, createFileRoute } from '@tanstack/react-router';
import { FcGoogle } from 'react-icons/fc';

import { Button } from '@/components/ui/button';

import BlueskyIcon from '@/components/BlueskyIcon';

import { signIn } from '@/lib/authClient';

export const Route = createFileRoute('/signin')({
  component: LoginPage,
  head: () => ({
    meta: [
      {
        name: 'Bluesky Trends Admin Sign In',
        content: 'Sign in to your account',
      },
      {
        title: 'Bluesky Trends Admin Sign In',
      },
    ],
  }),
});

function LoginPage() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
      <div className="w-full max-w-sm">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-6">
            <div className="flex flex-col items-center gap-2">
              <BlueskyIcon className="mb-2 size-6" />
              <h1 className="font-bold text-xl">Bluesky Trends Admin Login</h1>
              <div className="text-center text-sm">
                Don&apos;t have an account? Build your own app. It's fun!
              </div>
            </div>
            <Button
              variant="outline"
              className="mx-auto w-fit"
              onClick={() => signIn.social({ provider: 'google', callbackURL: '/admin' })}
            >
              <FcGoogle className="size-4" />
              Sign in with Google
            </Button>
          </div>
          <div className="text-balance text-center text-muted-foreground text-xs [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary">
            If you&apos;re not Joost, check out the <Link to="/">public site</Link>.
          </div>
        </div>
      </div>
    </div>
  );
}
